import { makeAutoObservable, onBecomeObserved } from "mobx"

import { APIPagination, referrerApi } from "@src/shared/api"
import { notify } from "../components/notify"

export interface IReferralsResponse {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20042Referrals
   */
  created_at?: string
  /**
   * Merchant\'s email
   * @type {string}
   * @memberof InlineResponse20042Referrals
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse20042Referrals
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20042Referrals
   */
  is_active?: boolean
  /**
   * posted transaction count
   * @type {number}
   * @memberof InlineResponse20042Referrals
   */
  total_transactions: number
}

class AffiliateProgramStore {
  private _links: any[] = []
  private _referrals: IReferralsResponse[] = []

  addLinkToDelete = (id: string) => {
    this.linksToDelete.push(id)
  }
  available: number = 0

  deleteLinks = async () => {
    if (this.linksToDelete.length > 0) {
      try {
        this.isLoading = true

        this.linksToDelete.forEach(async (id) => {
          const { data: result } =
            await referrerApi.deleteReferrerReferralLink(id)

          if (result.success) {
            // @ts-ignore
            this.getLinks()
          }
        })
      } finally {
        this.isLoading = false

        this.linksToDelete = []

        notify.success("Referral link deleted")
      }
    }
  }
  generateLink = async () => {
    try {
      this.isLoading = true

      const { data: result } = await referrerApi.createReferrerReferralLink()

      // @ts-ignore
      if (result.success) {
        // @ts-ignore
        this.getLinks()
      }
    } finally {
      this.isLoading = false
    }
  }

  getLinks = async () => {
    try {
      this.isLoading = true

      const { data: result } = await referrerApi.getReferrerReferralLinks()

      // @ts-ignore
      if (result.success) {
        // @ts-ignore
        this._links = result.data.data
      }
    } finally {
      this.isLoading = false
    }
  }

  getReferralsInfo = async () => {
    try {
      this.isLoading = true

      const { data: result } = await referrerApi.getReferrerReferrals()

      // @ts-ignore
      if (result.success) {
        // @ts-ignore
        this._referrals = result.data.referrals

        // @ts-ignore
        this.total = result.data.pagination?.total

        // @ts-ignore
        this.available = result.data.available
      }
    } finally {
      this.isLoading = false
    }
  }

  isLoading = false

  linksToDelete: string[] = []
  pageSize = 10

  total: APIPagination["total"] = 0

  constructor() {
    makeAutoObservable(this)
    onBecomeObserved(this, "_referrals", this.getReferralsInfo)
    onBecomeObserved(this, "_links", this.getLinks)
  }

  get links() {
    return this._links.map((item) => ({ key: item.id, ...item })) || []
  }

  get referrals() {
    return this._referrals.map((item) => ({ key: item.id, ...item })) || []
  }
}

export const affiliateProgramStore = new AffiliateProgramStore()
